import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import {States} from "../../shared/config/constant.module";
import template from './weeklyKPIsReport.tpl.html';
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {StateParams} from "../../common";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import * as Highcharts from 'highcharts/highstock';

let requires = [LoaderServiceName, ReportServiceName, NavigationServiceName];

function genericChart() {
  return {
    restrict: 'E',
    template: '<div></div>',
    scope: {
      options: '='
    },
    link: function (scope, element, attributes) {
      // Wait until finished loading, so that the dynamic id's will be ready
      angular.element(document).ready(function () {  
     
      // Load any charts with data (first time)
      try {
          var jsonData = JSON.parse(attributes.data);
          if (attributes.data != null && jsonData.length > 1) {  
            scope.options.series[0].data = jsonData;  
            new Highcharts.Chart(element[0], scope.options);
          }      
      } 
      catch (e) {        
          return false;
      }      

      // watch the data attribute and if it changes, update the chart series
      scope.$watch(function() { 
          return element.attr('data');
        }, function(newValue){  
          try {
            var jsonData = JSON.parse(attributes.data);
            if (newValue != null && jsonData.length > 1) {                      
              scope.options.series[0].data = jsonData;  
              new Highcharts.Chart(element[0], scope.options);      
            } 
          } 
          catch (e) {
            return false;
          }  
        });      
      });
    }
  };
}

function getDetailChartConfig() {
  return {
    chart: {
      alignTicks: true,
      zoomType: 'xy',
      height: 20,
      spacing: [0, 0, 0, 0],
      margin: [0, 0, 0, 0],
      events: {
        load: function() {
  
          const chart = this;
  
          let xAxisMin = chart.xAxis[0].dataMin,
            xAxisMax = chart.xAxis[0].dataMax,
            yAxisMin = chart.yAxis[0].dataMin,
            yAxisMax = chart.yAxis[0].dataMax;
  
          chart.update({
            xAxis: {
              min: xAxisMin + 1,
              max: xAxisMax - 1
            },
  
            yAxis: {
              min: yAxisMin - 1,
              max: yAxisMax + 1
            }
          });
          
        }
      }
    },     
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    title: {
      text: null,
      margin: 0,
      style: {
        display: 'none'
      }     
    },
    subtitle: {
      style: {
        display: 'none'
      }
    },
    xAxis: {
      categories: ['', '', '', ''],
      labels: {
        enabled: false
      },
      gridLineWidth: 0,
      visible: false
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        enabled: false
      },
      allowDecimals: false,
      gridLineWidth: 0,
      visible: false
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            enabled: false
          }
        },
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        animation: false
      }
    }, 
    tooltip: {  
      enabled: false
    },
    series: [{
      type: 'spline',
      data: [],
      color: '#919391',
      name: ''
    }]
  };
}

interface WeeklyKPIReportController {
  results: apsViewModels.PlantWeeklyKPIReport;  
  searchPerformed: boolean;  
  currentMonth: string;

  safetyData: apsViewModels.WeeklyKPIReportItem;
  tonsMelted: apsViewModels.WeeklyKPIReportItem;
  tonsPacked: apsViewModels.WeeklyKPIReportItem[];
  ptm: apsViewModels.WeeklyKPIReportItem;
  speed: apsViewModels.WeeklyKPIReportItem[];
  furnaceUtilization: apsViewModels.WeeklyKPIReportItem[];
  lineHolds: apsViewModels.WeeklyKPIReportItem;
  heldware: apsViewModels.WeeklyKPIReportItem;
  citDefects: apsViewModels.WeeklyKPIReportItem;
  weekEndingDates: apsViewModels.WeeklyItem[];
  detailChartConfig: any;

  generateReport(): void;
}

export interface WeeklyKPIReportParams extends StateParams {
  reportPlantId: string;
}

class WeeklyKPIReportCtrl implements WeeklyKPIReportController {
  plants: Plant[];
  selectedPlant: Plant;  
  form: angular.IFormController; 
  requirePlantSelection: boolean;

  private $stateParams: WeeklyKPIReportParams;
  private $state: angular.ui.IStateService;

  results: apsViewModels.PlantWeeklyKPIReport;
  searchPerformed: boolean;
  currentMonth: string;

  safetyData: apsViewModels.WeeklyKPIReportItem;
  tonsMelted: apsViewModels.WeeklyKPIReportItem;
  tonsPacked: apsViewModels.WeeklyKPIReportItem[];
  ptm: apsViewModels.WeeklyKPIReportItem;
  speed: apsViewModels.WeeklyKPIReportItem[];
  furnaceUtilization: apsViewModels.WeeklyKPIReportItem[];
  lineHolds: apsViewModels.WeeklyKPIReportItem;
  heldware: apsViewModels.WeeklyKPIReportItem;
  citDefects: apsViewModels.WeeklyKPIReportItem;
  weekEndingDates: apsViewModels.WeeklyItem[];
  detailChartConfig: any;

  loaderService: LoaderService;
  reportService: ReportService;
  private $q: angular.IQService;  
  

  constructor(
    $stateParams: WeeklyKPIReportParams,
    $state: angular.ui.IStateService,
    $q: angular.IQService,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService
  ) {
    this.$q = $q;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.reportService = reportService;

    this.requirePlantSelection = true;    

    this.detailChartConfig = getDetailChartConfig();

    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;      
     
      return this.loadState($stateParams);
    });

    loaderService.loadingPromise(promise);
  }

  loadState(params: WeeklyKPIReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportPlantId !== params.plantId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        this.selectedPlant = plant;        
      }
    } 

    return this.$q.when();
  }

  saveState() {
    var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
    if (reportPlantId === this.$stateParams.plantId) {
      reportPlantId = undefined;
    }
   
    var params: WeeklyKPIReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: reportPlantId     
    };

    this.$state.transitionTo(States.WEEKLY_KPI_REPORT, params);
  }

  generateReport() {
    if (this.form.$invalid) {
      return;
    }

    this.saveState();

    this.loaderService.loadingPromise(this.runReport());
  }

  private runReport(): angular.IPromise<any> {    
    
    return this.reportService.getWeeklyKpisReport(this.selectedPlant.id)
      .then(report => {
        this.results = report;
        this.searchPerformed = true;

        this.weekEndingDates = angular.copy(this.results.safetyKPI.weeklyItems);
        for (let index = 0; index < 4; index++) {
          
          this.weekEndingDates[index].endDate = moment(this.weekEndingDates[index].endDate).add(1, 'day').format("MM/DD");          
        }

        this.currentMonth = moment().format("MMMM");

        this.safetyData = this.results.safetyKPI;
        this.tonsMelted = this.results.tonsMeltedKPI;
        this.tonsPacked = this.results.tonsPackedKPI;
        this.ptm = this.results.ptmKPI;
        this.speed = this.results.speedKPI;
        this.furnaceUtilization = this.results.furnaceUtilizationKPI;
        this.lineHolds = this.results.lineHoldKPI;
        this.heldware = this.results.heldwareKPI;
        this.citDefects = this.results.citKPI;
      });
  }  

  getCellColor(value: number, target: number, defect: boolean): string{
    if (value == null)
      return 'gray';

    if (defect) {
      switch (value <= target) {
        case true:
          return 'green';    
        case false: 
          return 'red';
      }
    }  
    else {
      switch (value >= target) {
        case true:
          return 'green';    
        case false: 
          return 'red';
      }
    }  
  }

  getChartData(items: apsViewModels.WeeklyItem[]){
    return items.map(x => x.value);
  }

  updatePlant() {
    this.results = null;
  }
}

export default angular.module('aps.controller.weeklyKPIReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.WEEKLY_KPI_REPORT,
      url: '/admin/reports/weeklyKPIReport?reportPlantId',
      params: {        
        reportPlantId: {dynamic: true}     
      },
      controller: 'WeeklyKPIReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Weekly KPIs Report'
      }
    });
  })
  .controller('WeeklyKPIReportCtrl', WeeklyKPIReportCtrl)
  .directive('detailChart', genericChart)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/weeklyKPIsReport.controller.ts